// 葡萄牙语
export default {
    header_menu: {
        home: "Início",
        about: "Sobre nós",
        product: "Produtos",
        news: "Notícias",
        news_content: "Detalhes da notícia",
        download: "Centro de Downloads",
        contact: "Contacte-nos",
    },
    read_more: "Ler mais",
    prev: "Artigo anterior",
    next: "Próximo artigo",
    quick_navigation: "Navegação rápida",
    phone: "Telefone",
    whatsapp: "WhatsApp",
    email: "E-mail",
    address: "Endereço",
    your_name: "Seu nome",
    your_email: "Seu e-mail",
    content: "Conteúdo",
    please_input: "Por favor, insira ",
    leave_message: "Enviar solicitação",
    leave_success: "Mensagem enviada com sucesso",
    click_count: "Número de cliques",
    create_time: "Data de criação",
    upload_time: "Data de upload",
    //下载（动作）
    download: "Baixar",
    resources: "Recursos",
    products_type1: "Categorias de Produtos",
    products_type2: "Subcategorias",
    products_type3: "Subcategorias",
    products_list: "Lista de produtos",
    products_detail: "Detalhes do produto",
    products_video: "Vídeo do produto",
    send_message: "Enviar solicitação",
    products_content: "Conteúdo do produto",
    categories: "Categorias",
    send_email: "Enviar e-mail",
    call_time: "Horário de atendimento",
    our_location: "Nossa localização",
    leave_message_to_us: "Envie-nos uma solicitação",
    left_category: "Categorias",
    type_two: "Subcategorias",
    type_three: "Subcategorias",
    video_not_support: "Seu navegador não suporta a tag de vídeo.",
    about_us: "Sobre nós",
    no_data: "Sem dados",
    home_about_subtitle: "Fornecedor confiável de madeira e madeira compensada premium para compradores globais",
    home_products_title: "Nossos Produtos",
    home_products_subtitle: "Explore as nossas categorias de produtos principais",
    view_all: "Ver tudo",
    home_stat_countries: "Países atendidos",
    home_stat_capacity: "Produção anual (m³)",
    home_stat_years: "Anos de experiência",
    home_stat_clients: "Clientes globais",
    footer_follow: "Siga-nos no WeChat",
    footer_wechat: "WeChat",
    footer_copyright: "Debai Wood. Todos os direitos reservados.",
    home_visual_year: "Desde 2009",
    home_visual_quote: "Parceiro confiável de madeira e madeira compensada premium para compradores em mais de 60 países.",
    home_visual_tag: "FSC · ISO 9001 · CE Certificado",
    cta_title: "Procurando um fornecedor confiável de madeira e madeira compensada?",
    cta_sub: "Obtenha um orçamento competitivo e entrega mundial para os seus pedidos de madeira em grande volume.",
    get_a_quote: "Solicitar orçamento",
    home_banner_title: "Madeira e Compensado Premium para o Mundo",
    home_banner_sub: "Fornecedor global confiável atendendo mais de 60 países com qualidade certificada FSC, ISO 9001 e CE.",
    topbar_slogan: "Madeira e madeira compensada premium — A escolha confiável de compradores no mundo todo",
    contact_hero_tag: "Fale Conosco",
    page_title: {
        home: "Debai Wood | Fabricante e Fornecedor Global de Madeira e Compensado",
        about: "Sobre Nós | Debai Wood",
        products: "Produtos | Debai Wood",
        news: "Notícias | Debai Wood",
        download: "Central de Downloads | Debai Wood",
        contact: "Fale Conosco | Debai Wood",
        not_found: "Página Não Encontrada",
        back_home: "Voltar ao Início",
    },
    page_desc: {
        home: "Debai Wood é fabricante e fornecedor global de madeira e compensado, atendendo 60+ países com produtos certificados FSC, ISO 9001 e CE e entrega mundial.",
        about: "Conheça a Debai Wood — fabricante confiável de madeira e compensado com mais de 15 anos de experiência, clientes globais e gestão de qualidade certificada.",
        products: "Explore a linha completa de madeira e compensado Debai Wood: compensado fenólico, OSB, MDF, madeira serrada e soluções sob medida para compradores globais.",
        news: "Últimas notícias, feiras e insights do setor da Debai Wood — sua parceira confiável em madeira e compensado.",
        download: "Baixe catálogos de produtos, certificações (FSC, ISO 9001, CE) e fichas técnicas da Debai Wood para madeira e compensado.",
        contact: "Fale com a Debai Wood para cotações competitivas em pedidos de madeira e compensado. Entrega mundial e suporte B2B dedicado.",
    },
}
